import OrganizationFusionRequestApi from '@/api/OrganizationFusionRequestApi';
import { useModal, useNotif } from '@orion.ui/orion';
import { sanitizeMailPrefix } from '@/utils/tools';
import OrganizationApi from '@/api/OrganizationApi';
import OrganizationReleaseNote from '@/components/organization/OrganizationReleaseNote.vue';
import OrganizationFusionRequestModal from '@/components/organization/OrganizationFusionRequestModal.vue';
import OrganizationModalNameUpdate from '@/components/organization/OrganizationModalNameUpdate.vue';
import OrganizationModalCreatorTransfer from '@/components/organization/OrganizationModalCreatorTransfer.vue';

class OrganizationService {
	generateMail (payload: string) {
		const mail = sanitizeMailPrefix(payload);
		return `${mail}@myarmado.fr`;
	}

	async checkOrganizationNameAndEmailAsync (name: string, email: string) {
		try {
			await OrganizationApi.checkOrganizationNameAndEmail({
				name,
				email,
			});
			return {
				success: true,
				message: undefined,
			};
		} catch (e: any) {
			return {
				success: false,
				message: e.response.data,
			};
		}
	}

	async getDetailsByIdAsync (id: number) {
		const { data } = await OrganizationApi.selectById(id);
		return data;
	}

	async updateNameAndEmailAsync (id: number, payload: IUpdateOrganizationModel) {
		await OrganizationApi.update(id, payload);
		useNotif.success('Sauvegarde', 'Le nom et adresse mail de votre organisation a bien été modifiés');
	}

	async getDashboardStatsAsync () {
		const { data } = await OrganizationApi.dashboardStatistic();
		return data;
	}

	async showReleaseNoteModalAsync () {
		return new Promise<void>((resolve) => {
			useModal({
				Nested: OrganizationReleaseNote,
				size: 'sm',
				events: { 'leave-end': () => resolve() },
			});
		});
	}

	async createOrganizationFusionRequestAsync () {
		return new Promise<void>((resolve) => {
			useModal({
				Nested: OrganizationFusionRequestModal,
				size: 'sm',
				events: { 'leave-end': () => resolve() },
			});
		});
	}

	async openOrganizationModalNameUpdateAsync (organization: { name: string, email: string }) {
		return new Promise<{ name: string, email: string }>((resolve) => {
			useModal({
				size: 'sm',
				Nested: OrganizationModalNameUpdate,
				NestedProps: { organization },
				events: {
					saved: (Modal, payload: { name: string, email: string }) => {
						resolve(payload);
						Modal.close();
					},
				},
			});

		});
	}

	async openOrganizationModalCreatorTransferAsync () {
		return new Promise((resolve) => {
			useModal({
				Nested: OrganizationModalCreatorTransfer,
				NestedProps: { resolve },
				size: 'sm',
			});
		});
	}

	async listAsync (...args: Parameters<typeof OrganizationApi.list>) {
		const { data } = await OrganizationApi.list(...args);
		return data;
	}

	async getOverviewMarkersAsync (...args: Parameters<typeof OrganizationApi.overviewMarkers>) {
		const { data } = await OrganizationApi.overviewMarkers(...args);
		return data;
	}

	async fusionRequestGridAsync (...args: Parameters<typeof OrganizationFusionRequestApi.grid>) {
		const { data } = await OrganizationFusionRequestApi.grid(...args);
		return data;
	}

	async countFusionRequestWithoutResponseAsync (...args: Parameters<typeof OrganizationFusionRequestApi.countWithoutResponse>) {
		const { data } = await OrganizationFusionRequestApi.countWithoutResponse(...args);
		return data;
	}
}


export default function useOrganizationService () {
	return new OrganizationService();
}
